// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.magazine-admin .articles {
    margin: 0px;
}

.magazine-admin .headline {
    padding-top: 15px;
}

.magazine-admin .right {
    float: right;
}

.magazine-admin .inc-id {
    float: left;
    min-width: 5%;
}

.magazine-admin .date {
    float: left;
    min-width: 8%;
}

.magazine-admin .articles .item {
    border: 1px solid #e1e1e1;
    padding: 3px;
    margin-bottom: -1px;
}

.magazine-admin .articles .item .title {
}
`, "",{"version":3,"sources":["webpack://./src/components/magazine/magazine.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;AACA","sourcesContent":[".magazine-admin .articles {\n    margin: 0px;\n}\n\n.magazine-admin .headline {\n    padding-top: 15px;\n}\n\n.magazine-admin .right {\n    float: right;\n}\n\n.magazine-admin .inc-id {\n    float: left;\n    min-width: 5%;\n}\n\n.magazine-admin .date {\n    float: left;\n    min-width: 8%;\n}\n\n.magazine-admin .articles .item {\n    border: 1px solid #e1e1e1;\n    padding: 3px;\n    margin-bottom: -1px;\n}\n\n.magazine-admin .articles .item .title {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
